export default {"src":"/_next/static/media/delhi_ncr.a8027e41.svg","height":78,"width":132};